import { IProvider } from '@/shared/IProvider';
import { ProviderDialog } from './ProviderDialog'
import { makeAcronym } from '@/shared/parse';
import { CourseProviderStorage } from '../services/CourseProviderStorage';

export const NewProviderDialog = (props: {
  onClose: (open: boolean) => void;
  onSave: (provider: IProvider) => Promise<void>;
}) => {

  const defaultProvider: IProvider = {
    id: '',
    ProviderIdentifier: '',
    ProviderName: '',
    ProviderEmail: '',
    ProviderContact: '',
  }

  const onSave = async (data: IProvider, invite: boolean) => {
    const created = await CourseProviderStorage.createProvider({
      ...data,
      ProviderIdentifier: data.ProviderIdentifier || makeAcronym(data.ProviderName || ''),
    }, invite);
    props.onSave(created);
  }

  return (
    <ProviderDialog
      onClose={() => props.onClose(false)}
      provider={defaultProvider}
      onSave={onSave}
      saveLabel='Add New Provider'
      savingLabel='Adding...'
      title='Add New EIT UM Course Provider'
      description='This will register a new EIT UM course provider (not yet registered with the platform). An invitation will be sent to the provider to grant the access.'
    />
  )
}